(function() {
    // ⚠️ TESTING MODE - Set to true to show duplicate fields with red border
    const TESTING_MODE = false;

    const processedForms = new WeakSet();
    const styleUrl = "https://skincare.dermaconcepts.com/cdn/shop/t/13/assets/froms.css?v=171000607588358334491765355164";

    // Field mapping: top field ID -> address field ID
    const fieldMappings = [
        { source: 'first_name', target: 'shipping_address_first_name' },
        { source: 'last_name', target: 'shipping_address_last_name' },
        { source: 'phone_number', target: 'shipping_address_phone' }
    ];

    
    function applyCustomStyles(shadowRoot) {
        // Check if styles already applied
        if (shadowRoot.querySelector('link[href*="froms.css"]')) {
            return;
        }

        const link = document.createElement('link');
        link.rel = "stylesheet";
        link.href = styleUrl;
        shadowRoot.appendChild(link);
    }

    function hideAddressFields(shadowRoot) {
        fieldMappings.forEach(mapping => {
            const targetField = shadowRoot.getElementById(mapping.target);
            if (targetField) {
                // Remove hidden field from tab order
                targetField.setAttribute('tabindex', '-1');

                // For phone fields, we need to hide the entire phone container (including country selector)
                if (mapping.target.includes('phone')) {
                    // Look for phone container or the multi-line field container
                    let container = targetField.closest('div');
                    let attempts = 0;
                    const maxAttempts = 5;

                    while (container && container !== shadowRoot && attempts < maxAttempts) {
                        // Check if this container has the phone country selector
                        const hasPhoneSelector = container.querySelector('.phone-country-selector');

                        if (hasPhoneSelector) {
                            // Remove country selector button from tab order
                            const countryButton = hasPhoneSelector.querySelector('button');
                            if (countryButton) {
                                countryButton.setAttribute('tabindex', '-1');
                            }

                            if (TESTING_MODE) {
                                // In testing mode, highlight instead of hiding
                                container.style.border = '2px solid #ff6b6b';
                                container.style.backgroundColor = '#fff5f5';
                                targetField.style.border = '2px solid #ff6b6b';
                            } else {
                                // Hide the entire container that includes both selector and input
                                container.style.display = 'none';
                            }
                            break;
                        }

                        container = container.parentElement;
                        attempts++;
                    }
                } else {
                    // For regular fields (first name, last name), find the field container
                    let container = targetField.parentElement;

                    // Traverse up to find the main field container (usually 1-3 levels up)
                    while (container && container !== shadowRoot) {
                        // Check if this looks like a field container (has an input and label)
                        const hasInput = container.querySelector('input, select, textarea');
                        const hasLabel = container.querySelector('label');

                        if (hasInput && hasLabel && container.parentElement) {
                            if (TESTING_MODE) {
                                // In testing mode, highlight instead of hiding
                                container.style.border = '2px solid #ff6b6b';
                                container.style.backgroundColor = '#fff5f5';
                                targetField.style.border = '2px solid #ff6b6b';
                            } else {
                                container.style.display = 'none';
                            }
                            break;
                        }
                        container = container.parentElement;
                    }
                }
            }
        });
    }

    function syncFields(shadowRoot) {
        fieldMappings.forEach(mapping => {
            const sourceField = shadowRoot.getElementById(mapping.source);
            const targetField = shadowRoot.getElementById(mapping.target);

            if (sourceField && targetField) {
                // Function to sync field values
                function syncValue() {
                    targetField.value = sourceField.value;
                    // Trigger change event on target field
                    targetField.dispatchEvent(new Event('input', { bubbles: true }));
                    targetField.dispatchEvent(new Event('change', { bubbles: true }));
                }

                // Sync immediately if source has value
                if (sourceField.value) {
                    syncValue();
                }

                // Add event listeners for real-time sync
                ['input', 'change', 'blur', 'keyup'].forEach(eventType => {
                    sourceField.addEventListener(eventType, syncValue);
                });

                // For phone fields, also watch for country selector changes
                if (mapping.source.includes('phone')) {
                    // Find source and target country selectors
                    let sourcePhoneContainer = sourceField.parentElement;
                    while (sourcePhoneContainer && !sourcePhoneContainer.querySelector('.phone-country-selector')) {
                        sourcePhoneContainer = sourcePhoneContainer.parentElement;
                        if (sourcePhoneContainer === shadowRoot) break;
                    }

                    let targetPhoneContainer = targetField.parentElement;
                    while (targetPhoneContainer && !targetPhoneContainer.querySelector('.phone-country-selector')) {
                        targetPhoneContainer = targetPhoneContainer.parentElement;
                        if (targetPhoneContainer === shadowRoot) break;
                    }

                    if (sourcePhoneContainer && targetPhoneContainer) {
                        const sourceCountryButton = sourcePhoneContainer.querySelector('.phone-country-selector button');
                        const targetCountryButton = targetPhoneContainer.querySelector('.phone-country-selector button');

                        if (sourceCountryButton && targetCountryButton) {
                            // Watch for clicks on source country selector button
                            sourceCountryButton.addEventListener('click', function() {
                                // Wait for dropdown to appear
                                setTimeout(function() {
                                    const sourceDropdown = shadowRoot.querySelector('[id*="country-selector-dropdown"]');

                                    if (sourceDropdown) {
                                        // Get all option items in source dropdown
                                        const sourceOptions = sourceDropdown.querySelectorAll('[id*="select-country-"]');

                                        sourceOptions.forEach(function(sourceOption) {
                                            sourceOption.addEventListener('click', function() {
                                                // Extract country code from ID (e.g., "select-country-US" -> "US")
                                                const optionId = sourceOption.getAttribute('id');
                                                const countryCode = optionId ? optionId.replace('select-country-', '') : null;

                                                if (countryCode) {
                                                    // First, sync the input value
                                                    setTimeout(syncValue, 50);

                                                    // Then, trigger click on target country selector
                                                    setTimeout(function() {
                                                        // Click target country button to open its dropdown
                                                        targetCountryButton.click();

                                                        // Wait for target dropdown to open
                                                        setTimeout(function() {
                                                            const targetDropdown = shadowRoot.querySelector('[id*="country-selector-dropdown"]');
                                                            if (targetDropdown) {
                                                                // Find and click the same country option in target dropdown
                                                                const targetOption = targetDropdown.querySelector('#select-country-' + countryCode);
                                                                if (targetOption) {
                                                                    targetOption.click();
                                                                    // Sync values after selection
                                                                    setTimeout(syncValue, 50);
                                                                    setTimeout(syncValue, 150);
                                                                }
                                                            }
                                                        }, 100);
                                                    }, 150);
                                                }
                                            }, { once: false });
                                        });
                                    }
                                }, 150);
                            });
                        }
                    }

                    // Also watch for direct value changes in source field
                    const valueObserver = new MutationObserver(syncValue);
                    valueObserver.observe(sourceField, {
                        attributes: true,
                        attributeFilter: ['value']
                    });
                }
            }
        });
    }

    function setupCompanyNameAutofill(shadowRoot) {
        // Only run on the licensed-professional-account page
        if (!window.location.pathname.includes('pages/licensed-professional-account')) {
            return;
        }

        const firstNameField = shadowRoot.getElementById('first_name');
        const lastNameField = shadowRoot.getElementById('last_name');
        const companyNameField = shadowRoot.getElementById('company_name');

        // Only proceed if all three fields exist
        if (!firstNameField || !lastNameField || !companyNameField) {
            return;
        }

        // Hide the company name field and remove from tab order
        companyNameField.setAttribute('tabindex', '-1');

        // Find and hide the company name field container
        let container = companyNameField.parentElement;
        while (container && container !== shadowRoot) {
            // Check if this looks like a field container (has an input and label)
            const hasInput = container.querySelector('input, select, textarea');
            const hasLabel = container.querySelector('label');

            if (hasInput && hasLabel && container.parentElement) {
                if (TESTING_MODE) {
                    // In testing mode, highlight instead of hiding
                    container.style.border = '2px solid #4CAF50';
                    container.style.backgroundColor = '#f1f8f4';
                    companyNameField.style.border = '2px solid #4CAF50';
                } else {
                    container.style.display = 'none';
                }
                break;
            }
            container = container.parentElement;
        }

        // Function to update company name from first and last name
        function updateCompanyName() {
            const firstName = firstNameField.value.trim();
            const lastName = lastNameField.value.trim();

            // Combine first name first, then last name with a space
            const companyName = [firstName, lastName].filter(Boolean).join(' ');

            if (companyName) {
                companyNameField.value = companyName;
                // Trigger events to ensure form validation updates
                companyNameField.dispatchEvent(new Event('input', { bubbles: true }));
                companyNameField.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }

        // Add event listeners to both first and last name fields
        ['input', 'change', 'blur', 'keyup'].forEach(eventType => {
            firstNameField.addEventListener(eventType, updateCompanyName);
            lastNameField.addEventListener(eventType, updateCompanyName);
        });

        // Update immediately if fields already have values
        if (firstNameField.value || lastNameField.value) {
            updateCompanyName();
        }
    }

    function processForm(formElement) {
        // Avoid processing the same form twice
        if (processedForms.has(formElement)) {
            return;
        }

        const shadowRoot = formElement.shadowRoot;
        if (!shadowRoot) {
            return;
        }

        // Mark as processed
        processedForms.add(formElement);

        // Apply custom styles
        applyCustomStyles(shadowRoot);

        // Wait for form fields to be rendered (retry mechanism)
        let retryCount = 0;
        const maxRetries = 30;

        function setupFieldSync() {
            const firstField = shadowRoot.getElementById('first_name');

            if (firstField) {
                hideAddressFields(shadowRoot);
                syncFields(shadowRoot);
                setupCompanyNameAutofill(shadowRoot);
            } else if (retryCount < maxRetries) {
                retryCount++;
                setTimeout(setupFieldSync, 100);
            }
        }

        setupFieldSync();
    }

    function findAndProcessForms() {
        const formElements = document.querySelectorAll('shopify-forms-embed');
        formElements.forEach(processForm);
    }

    // Initial check
    function init() {
        findAndProcessForms();

        // Watch for dynamically added forms
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) {
                        if (node.tagName === 'SHOPIFY-FORMS-EMBED') {
                            processForm(node);
                        }
                        // Check for nested forms
                        const nestedForms = node.querySelectorAll && node.querySelectorAll('shopify-forms-embed');
                        if (nestedForms) {
                            nestedForms.forEach(processForm);
                        }
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// Cart Update Listener - Logs whenever cart is updated (add/update/delete)
document.addEventListener('cart:updated', function(event) {
    console.log('🛒 Cart Updated:', event.detail.cart);
    console.log('Total Items:', event.detail.cart.item_count);
    console.log('Cart Total:', event.detail.cart.total_price);
    console.log('Cart Items:', event.detail.cart.items);
});
